import React, { useEffect, useRef } from "react";
import { INSTITUTES, TESTIMONIALS, DOCTORS } from "../constants";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  ShieldAlert,
  Calendar,
  UserSearch,
  ClipboardCheck,
  CheckCircle2,
  Award,
  Phone,
  Activity,
  UserCheck,
  Quote,
  MapPin,
} from "lucide-react";
import banner from "../assets/home_page_banner.png";
import home_about from "../assets/reliable.jpeg";
import reliable from "../assets/home_about.JPG";
import bannerVideo from "../assets/home_banner_video.MP4";

const Home = () => {
  const observerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -80px 0px",
      },
    );

    const elements = Array.from(document.querySelectorAll(".reveal"));

    elements.forEach((el) => observer.observe(el));

    observerRef.current = observer;

    return () => {
      observer.disconnect();
      observerRef.current = null;
    };
  }, []);

  return (
    <div className="bg-white">
      {/* --- PROFESSIONAL CLINICAL HERO --- */}
      <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 bg-slate-50 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 relative z-10 animate-fade-in-up">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            {/* Left Content */}
        <div className="max-w-2xl px-4 sm:px-0">

  {/* Tag line */}
  <div className="flex items-center gap-2 mb-4 sm:mb-6 text-vcnr-brand font-semibold text-xs sm:text-sm uppercase">
    <Award size={16} className="animate-pulse sm:size-[18px]" />
    NABH Accredited Tertiary Care Hospital
  </div>

  {/* Heading */}
  <h1 className="text-3xl sm:text-4xl md:text-6xl font-semibold mb-4 sm:mb-6 leading-tight">
    Advanced Medicine, <br />
    <span className="text-vcnr-brand">Compassionate Care.</span>
  </h1>

  {/* Description */}
  <p className="text-base sm:text-lg text-slate-600 mb-8 sm:mb-10 max-w-xl">
    VCNR Hospital is committed to providing world-class tertiary
    healthcare through specialized clinical institutes and
    state-of-the-art medical technology.
  </p>

  {/* Buttons */}
  <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-10 sm:mb-12">
    <Link
      to="/booking"
      className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-vcnr-brand text-white rounded-lg font-bold text-sm hover:bg-slate-900 transition-all flex items-center justify-center gap-2 shadow-lg shadow-vcnr-brand/20 hover:scale-105 active:scale-95"
    >
      <Calendar size={16} className="sm:size-[18px]" />
      Book Appointment
    </Link>

    <Link
      to="/doctors"
      className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white border border-slate-200 text-slate-700 rounded-lg font-bold text-sm hover:bg-slate-50 transition-all flex items-center justify-center gap-2 hover:border-vcnr-brand hover:text-vcnr-brand hover:scale-105 active:scale-95"
    >
      <UserSearch size={16} className="sm:size-[18px]" />
      Find a Specialist
    </Link>
  </div>

  {/* Stats Section */}
  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-8 py-5 sm:py-6 border-t border-slate-200">

    {/* Emergency */}
    <div className="flex items-center gap-3 group">
      <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-vcnr-brand/10 flex items-center justify-center text-vcnr-brand group-hover:bg-vcnr-brand group-hover:text-white transition-colors">
        <Activity size={18} className="sm:size-[20px]" />
      </div>
      <div>
        <div className="text-base sm:text-lg font-bold text-slate-900">24/7</div>
        <div className="text-[10px] text-slate-500 uppercase font-bold">
          Emergency
        </div>
      </div>
    </div>

    {/* Experts */}
    <div className="flex items-center gap-3 group">
      <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-vcnr-brand/10 flex items-center justify-center text-vcnr-brand group-hover:bg-vcnr-brand group-hover:text-white transition-colors">
        <UserCheck size={18} className="sm:size-[20px]" />
      </div>
      <div>
        <div className="text-base sm:text-lg font-bold text-slate-900">50+</div>
        <div className="text-[10px] text-slate-500 uppercase font-bold">
          Experts
        </div>
      </div>
    </div>

  </div>
</div>


            {/* Right Banner Image */}
            {/* <div className="hidden lg:block relative">
              <div className="absolute -inset-4 bg-vcnr-brand/5 rounded-3xl -rotate-3 animate-pulse-slow"></div>
              <div className="relative h-[550px] w-full rounded-3xl overflow-hidden shadow-2xl border-8 border-white group">
                <img
                  src={banner}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  alt="VCNR Hospital Facility"
                />
                <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-md p-6 rounded-2xl shadow-xl border border-slate-100 transform transition-transform group-hover:-translate-y-2">
                  <div className="flex items-center gap-3">
                    <ShieldAlert
                      className="text-red-600 animate-pulse"
                      size={24}
                    />
                    <div>
                      <div className="text-sm font-bold text-slate-900">
                        Emergency Support
                      </div>
                      <div className="text-xs text-slate-500 font-medium italic">
                        Call 1066 for immediate trauma response
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="hidden lg:block relative">
  <div className="absolute -inset-4 bg-vcnr-brand/5 rounded-3xl -rotate-3 animate-pulse-slow"></div>

  <div className="relative h-[550px] w-full rounded-3xl overflow-hidden shadow-2xl border-8 border-white group">
    
    <video
      src={bannerVideo}
      autoPlay
      loop
      muted
      playsInline
      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
    />

    <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-md p-6 rounded-2xl shadow-xl border border-slate-100 transform transition-transform group-hover:-translate-y-2">
      <div className="flex items-center gap-3">
        <ShieldAlert
          className="text-red-600 animate-pulse"
          size={24}
        />
        <div>
          <div className="text-sm font-bold text-slate-900">
            Emergency Support
          </div>
          <div className="text-xs text-slate-500 font-medium italic">
            Call 1066 for immediate trauma response
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
          </div>
        </div>
      </section>

      {/* --- QUICK SERVICES RIBBON --- */}
      <div className="bg-white border-y border-slate-100  reveal">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                label: "Health Checkups",
                sub: "Preventive Care",
                icon: <ClipboardCheck />,
                link: "/booking",
              },
              {
                label: "Radiology & Labs",
                sub: "Advanced Diagnostics",
                icon: <Activity />,
                link: "/",
              },
              {
                label: "Pharmacy",
                sub: "24/7 Availability",
                icon: <ShieldAlert />,
                link: "/",
              },
              {
                label: "Emergency Call",
                sub: "Dial 1066 Now",
                icon: <Phone />,
                link: "tel:1066",
                highlight: true,
              },
            ].map((item, i) => (
              <Link
  key={i}
  to={item.link}
  className={`flex items-center gap-3 sm:gap-4 group p-3 sm:p-4 rounded-xl transition-all hover:scale-105 ${
    item.highlight
      ? "bg-red-50 hover:bg-red-100"
      : "hover:bg-slate-50"
  }`}
>
  <div
    className={`w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center transition-all ${
      item.highlight
        ? "bg-red-600 text-white"
        : "bg-vcnr-brand/10 text-vcnr-brand group-hover:bg-vcnr-brand group-hover:text-white group-hover:rotate-12"
    }`}
  >
    {React.cloneElement(item.icon, {
      size: window.innerWidth < 640 ? 20 : 24
    })}
  </div>

  <div>
    <div
      className={`text-xs sm:text-sm font-bold leading-tight ${
        item.highlight ? "text-red-700" : "text-slate-900"
      }`}
    >
      {item.label}
    </div>

    <div className="text-[9px] sm:text-[10px] text-slate-400 uppercase font-semibold tracking-wide">
      {item.sub}
    </div>
  </div>
</Link>

            ))}
          </div>
        </div>
      </div>

      {/* --- ABOUT SECTION --- */}
      <section className="py-24 bg-white overflow-hidden reveal">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="relative order-2 lg:order-1 group">
              <div className="absolute -inset-4 bg-slate-100 rounded-3xl rotate-2 transition-transform group-hover:rotate-0 duration-500"></div>
              <img
                src={home_about}
                className="relative rounded-3xl shadow-xl w-full h-[450px] object-cover transition-transform duration-500 group-hover:scale-105"
                alt="VCNR Medical Care"
              />
            </div>
            <div className="order-1 lg:order-2">
              <div className="flex items-center gap-2 mb-4">
                <div className="h-1 w-12 bg-vcnr-brand rounded-full"></div>
                <span className="text-vcnr-brand text-[12px] font-bold uppercase tracking-[0.1em]">
                  About VCNR Hospital
                </span>
              </div>
               {/* <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-8 leading-tight tracking-tight uppercase"></h2> */}
              <h2 className="text-4xl md:text-[3rem]  font-semibold text-slate-900 mb-8 leading-tight">
                A Legacy of Clinical <br/>
                <span className="text-vcnr-brand">Excellence.</span>
              </h2>
              <p className="text-slate-600 text-lg mb-8">
                VCNR Hospital stands as a beacon of advanced healthcare,
                integrating specialized medical expertise with sophisticated
                infrastructure. Our mission is to provide comprehensive,
                evidence-based tertiary care that prioritizes patient outcomes
                and safety. From advanced diagnostics to complex surgical
                interventions, our board-certified clinical experts work across
                nine specialized institutes to ensure every patient receives
                personalized treatment of the highest standard.
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="p-4 bg-slate-50 rounded-xl border border-slate-100 hover:border-vcnr-brand transition-colors group">
                  <div className="text-2xl font-black text-slate-900 mb-1 group-hover:text-vcnr-brand transition-colors">
                    NABH
                  </div>
                  <div className="text-[10px] text-slate-500 font-bold uppercase tracking-wider">
                    Quality Accredited
                  </div>
                </div>
                <div className="p-4 bg-slate-50 rounded-xl border border-slate-100 hover:border-vcnr-brand transition-colors group">
                  <div className="text-2xl font-black text-slate-900 mb-1 group-hover:text-vcnr-brand transition-colors">
                    Modern
                  </div>
                  <div className="text-[10px] text-slate-500 font-bold uppercase tracking-wider">
                    Infrastructure
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- THE NINE INSTITUTES (REQUESTED CARD GRID) --- */}
      <section className="pb-24 bg-slate-50 hospital-grid border-t border-slate-100 reveal">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-vcnr-brand text-[12px] font-bold uppercase tracking-[0.1em]">
              Specialized Units
            </span>
            <h2 className="text-4xl md:text-[3rem]  font-semibold text-slate-900 mb-8 leading-tight">
              VCNR Institutes
            </h2>
            <div className="h-1.5 w-16 bg-vcnr-brand mx-auto rounded-full mt-6"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {INSTITUTES.map((inst) => (
              <div
                key={inst.id}
                className="bg-white rounded-2xl overflow-hidden shadow-sm border border-slate-200 hover:border-vcnr-brand hover:shadow-2xl transition-all duration-500 flex flex-col group hover:-translate-y-2"
              >
                {/* 1. Image (Top) */}
                <div className="h-64 relative overflow-hidden shrink-0">
                  <img
                    src={inst.image}
                    alt={inst.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  {/* {inst.id === "musculo-skeletal" && (
                    <div className="absolute top-4 right-4 bg-vcnr-brand text-white px-4 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest shadow-lg animate-pulse">
                      Orthopedics
                    </div>
                  )} */}
                </div>

                {/* 2. Heading, Description, Button */}
                <div className="p-10 flex flex-col flex-grow">
                  <h4 className="text-xl font-semibold text-slate-900 uppercase  mb-4 group-hover:text-vcnr-brand transition-colors">
                    {inst.name}
                  </h4>

                  <p className="text-slate-600 text-lg mb-8">
                    {inst.description}
                  </p>

                  <Link
                    to={`/institute/${inst.id}`}
                    className="mt-auto inline-flex items-center justify-center gap-3 px-8 py-4 bg-slate-900 text-white rounded-xl  font-normal uppercase  hover:bg-vcnr-brand transition-all shadow-md group-hover:shadow-lg active:scale-95"
                  >
                    View Details{" "}
                    <ArrowRight
                      size={14}
                      className="group-hover:translate-x-2 transition-transform"
                    />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- TRUST SECTION --- */}
      <section className="pb-24 bg-white reveal">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="relative group">
              <img
                src={reliable}
                className="relative rounded-[2rem] shadow-2xl object-cover h-[500px] w-full transition-transform duration-500 group-hover:scale-[1.02]"
                alt="Clinical Protocols"
              />
              <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-2xl shadow-xl border border-slate-100 max-w-xs hidden md:block transition-transform duration-500 group-hover:translate-x-2 group-hover:-translate-y-2">
                <div className="flex items-center gap-3 mb-2">
                  <div className="text-vcnr-brand font-semibold">
                    Clinical Priority
                  </div>
                </div>
                <p className="text-xs text-slate-600 font-medium ">
                  Adhering to international safety standards to provide the best
                  clinical outcomes.
                </p>
              </div>
            </div>

            <div>
              <span className="text-vcnr-brand text-[12px] font-bold uppercase tracking-[0.1em]">
                Patient-Centered
              </span>
              <h3 className="text-4xl md:text-[3rem]  font-semibold text-slate-900 mb-8 leading-tight">
                Reliable Care For <br /> <span className="text-vcnr-brand">Your Family</span>.
              </h3>

              <div className="space-y-6">
                <div className="flex gap-4 group">
                  <div className="w-10 h-10 rounded-full bg-slate-50 border border-slate-100 flex items-center justify-center text-vcnr-brand shrink-0 group-hover:bg-vcnr-brand group-hover:text-white transition-all">
                    <CheckCircle2 size={20} />
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-1 uppercase ">
                      Advanced Diagnostic Lab
                    </h4>
                    <p className="text-slate-600 text-lg mb-8">
                      Our 24/7 diagnostic lab provides precise and timely
                      clinical results.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4 group">
                  <div className="w-10 h-10 rounded-full bg-slate-50 border border-slate-100 flex items-center justify-center text-vcnr-brand shrink-0 group-hover:bg-vcnr-brand group-hover:text-white transition-all">
                    <CheckCircle2 size={20} />
                  </div>
                  <div>
                    <span className="font-bold text-slate-900 mb-1 uppercase ">
                      Board-Certified Specialists
                    </span>
                    <p className="text-slate-600 text-lg mb-8">
                      Internationally trained consultants leading each
                      specialized unit.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-12 flex items-center gap-6">
                <Link
                  to="/booking"
                  className="px-8 py-4 bg-slate-900 text-white rounded-lg font-semibold  hover:bg-vcnr-brand transition-all shadow-xl hover:scale-105 active:scale-95"
                >
                  Schedule Consultation
                </Link>
                <div className="text-xs">
                  <div className="font-semibold text-slate-900 uppercase">
                    Emergency Desk
                  </div>
                  <div className="text-red-600 font-bold text-lg animate-pulse">
                    1066
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- DOCTOR PREVIEW --- */}
      <section className="pb-24 bg-slate-50 reveal">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row items-end justify-between mb-16 gap-8 text-center md:text-left">
            <div>
              <span className="text-vcnr-brand text-[12px] font-bold uppercase tracking-[0.1em]">
                Our Experts
              </span>
              <h2 className="text-4xl md:text-[3rem]  font-semibold text-slate-900 mb-8 leading-tight
">
                Clinical Board <span className="text-vcnr-brand">Members</span>
              </h2>
            </div>
            <Link
              to="/doctors"
              className="text-sm font-semibold text-vcnr-brand flex items-center gap-2 hover:gap-4 transition-all uppercase  group"
            >
              Full Directory{" "}
              <ArrowRight
                size={16}
                className="transition-transform group-hover:translate-x-1"
              />
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {DOCTORS.slice(0, 4).map((doc) => (
              <div
                key={doc.id}
                className="bg-white rounded-xl overflow-hidden shadow-sm border border-slate-200 group hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
              >
                <div className="h-64 overflow-hidden relative">
                  <img
                    src={doc.image}
                    alt={doc.name}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-110"
                  />
                  <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-md px-3 py-1 rounded text-[10px] font-semibold text-slate-900 uppercase ">
                    {doc.exp} Exp
                  </div>
                </div>
                <div className="p-6">
                  <div className="text-[12px] font-bold text-vcnr-brand uppercase  mb-1">
                    {doc.specialty}
                  </div>
                  <h4 className="text-lg font-bold text-slate-900 mb-4 group-hover:text-vcnr-brand transition-colors">
                    {doc.name}
                  </h4>
                  <Link
                    to="/booking"
                    className="mt-auto inline-flex items-center justify-center gap-3 px-8 py-4 bg-slate-900 text-white rounded-xl text-[12px]  font-semibold uppercase tracking-widest hover:bg-vcnr-brand transition-all shadow-md group-hover:shadow-lg active:scale-95"
                  >
                    <Calendar size={14} /> Book Slot
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- PATIENT TESTIMONIALS --- */}
      <section className="pb-24 bg-white reveal">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-vcnr-brand text-[12px] font-bold uppercase tracking-[0.1em]">
              Patient Experiences
            </span>
            <h2 className="text-4xl md:text-[3rem]  font-semibold text-slate-900 mb-8 leading-tight">
              Voices of Recovery
            </h2>
            <div className="h-1.5 w-16 bg-vcnr-brand mx-auto rounded-full mt-6"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {TESTIMONIALS.map((t) => (
              <div
                key={t.id}
                className="bg-slate-50 p-10 rounded-3xl border border-slate-100 flex flex-col relative group hover:bg-white hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
              >
                <div className="text-vcnr-brand/20 absolute top-6 right-8 group-hover:text-vcnr-brand/40 transition-colors">
                  <Quote
                    size={48}
                    fill="currentColor"
                    className="transition-transform group-hover:rotate-12"
                  />
                </div>

                <p className="text-slate-600 italic leading-relaxed text-sm mb-10 relative z-10">
                  "{t.content}"
                </p>

                <div className="mt-auto flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-white shadow-sm shrink-0 transition-transform group-hover:scale-110">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <div className=" font-semibold text-slate-900">
                      {t.name}
                    </div>
                    {/* <div className="text-[10px] font-black text-vcnr-brand uppercase tracking-widest">
                      {t.role}
                    </div> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- FINAL CTA --- */}
      <section className="pb-20 bg-slate-50 reveal">
        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-vcnr-brand rounded-[2.5rem] p-12 md:p-20 text-white flex flex-col items-center text-center relative overflow-hidden shadow-2xl group">
            <div className="relative z-10">
              <h2 className="text-4xl md:text-[3rem]  font-semibold text-slate-900 mb-8 leading-tight duration-500 text-white">
                Specialized Care is a <br /> Click Away.
              </h2>
              <p className="text-lg text-white mb-12 max-w-2xl mx-auto ">
                Our specialized medical board is available for professional
                consultation. We prioritize your recovery and well-being with
                international quality standards.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-6">
                <Link
                  to="/booking"
                  className="bg-white text-vcnr-brand px-12 py-5 rounded-xl font-black uppercase text-xs tracking-[0.1em] shadow-xl hover:bg-slate-900 hover:text-white transition-all hover:scale-110 active:scale-95"
                >
                  Request Appointment
                </Link>
                <a
                  href="tel:1066"
                  className="bg-red-600 text-white px-12 py-5 rounded-xl font-black uppercase text-xs tracking-[0.1em] flex items-center justify-center gap-3 hover:bg-red-700 transition-all hover:scale-110 active:scale-95"
                >
                  <Phone size={18} /> Emergency: 1066
                </a>
              </div>
            </div>
            <div className="absolute inset-0 opacity-10 pointer-events-none hospital-grid group-hover:scale-150 transition-transform duration-[20s]"></div>
          </div>
        </div>
      </section>

      <div className="bg-slate-900 py-10 px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-6">
            <div className="w-12 h-12 bg-vcnr-brand/20 rounded-xl flex items-center justify-center text-vcnr-brand">
              <MapPin size={24} />
            </div>
            <div>
              <div className="text-[12px] font-semibold text-slate-400 uppercase tracking-widest mb-1">
                Facility Address
              </div>
              <div className="  text-white uppercase ">
                Opp Binnamangala Nursery, B.H. Road, Nelamangala - 562123,
                Bangalore.
              </div>
            </div>
          </div>
          <div className="flex gap-4">
            <a
              href="/booking"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3 bg-white text-slate-900 rounded-xl text-[12px] font-bold uppercase  hover:bg-vcnr-brand hover:text-white transition-all"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
